import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCar = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 30,
	viewBox: "0 0 30 30",
	width: 30,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "m1122.058 379.676.014.968a.426.426 0 0 0 .433.416h2.6a.426.426 0 0 0 .433-.416v-5.468a2.077 2.077 0 0 0 -.42-1.407l-.474-.559 1.166-.51c.085-.037.148-.073.124-.163l-.186-.667a.591.591 0 0 0 -.537-.406h-2.047l-1.373-2.081a1.021 1.021 0 0 0 -.684-.367 74.7 74.7 0 0 0 -10.341 0 1.023 1.023 0 0 0 -.684.367l-1.372 2.081h-2.047a.593.593 0 0 0 -.537.406l-.186.667c-.025.088.039.126.124.163l1.166.51-.474.559a2.085 2.085 0 0 0 -.419 1.407v5.468a.426.426 0 0 0 .433.416h2.6a.426.426 0 0 0 .433-.416l.014-.96a121.141 121.141 0 0 0 12.236-.008zm-14.309-4.528 2.826.336m13.556-.336-2.826.336",
			stroke: "currentColor",
			strokeLinejoin: "round",
			transform: "translate(-1101.322 -360.337)"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 15
		})]
	})
});
export default SvgCar;
